import React, { memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import * as S from './style';

interface IProps {
  text?: React.ReactNode;
  className?: string;
  bottom?: number;
  isIPhoneXApp?: boolean;
}

const ToastPopup = ({ text, className, bottom = 60, isIPhoneXApp }: IProps) => {
  const cName = classNameBind([
    `toast-popup${isIPhoneXApp ? ' is-old-app-iphonex' : ''}`,
    className || '',
  ]);

  return (
    <S.ToastPopup className={cName} $bottom={String(bottom)}>
      <Text>{text}</Text>
    </S.ToastPopup>
  );
};

export default memo(ToastPopup);
